export enum SaleChannelTags {
  ONLINE_AUCTION = "Online Auction",
  BUY_NOW = "Buy now",
  BID_NOW = "Bid now",
  HYBRID = "Hybrid",
}
